import { useCallback, useEffect, useState } from "react";
import { terminalQrService } from "@/services/terminalQrService";
import { useLanguage } from "@/context/LanguageContext";

/**
 * QR Code do terminal, gerado pelo servidor e renovado em segundo plano.
 * Nenhuma informação de expiração é mostrada ao cliente.
 */
export const TerminalQrCard = () => {
  const { t } = useLanguage();
  const [qr, setQr] = useState(null);

  const load = useCallback(async () => {
    try {
      setQr(await terminalQrService.current());
    } catch {
      setQr(null);
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 60 * 60 * 1000);
    return () => clearInterval(id);
  }, [load]);

  if (!qr) return null;

  return (
    <div data-testid="terminal-qr-card"
         className="flex w-full flex-col items-center gap-3 rounded-md border border-[#22252F] bg-[#0F1116] p-5 sm:max-w-[220px]">
      <p className="text-[11px] uppercase tracking-[0.2em] text-[#60A5FA]">{t("dash.qrTitle")}</p>
      <img data-testid="terminal-qr-image" src={qr.image} alt={t("dash.qrTitle")}
           className="h-[150px] w-[150px] rounded bg-white p-2" />
      <p className="text-center text-xs leading-relaxed text-[#94A3B8]">{t("dash.qrHint")}</p>
    </div>
  );
};
